import {$scrollIntoView} from "@/utils/utils";

const install = function (Vue) {
    Vue.prototype.$scrollIntoView = $scrollIntoView
}
export default install
